export const FETCH_NEW_TOKEN_INFO = 'FETCH_NEW_TOKEN_INFO'

export const FETCH_USER_INFO = 'FETCH_USER_INFO'

export const TOKEN_KEY = [...'nekot_resu'].reverse().join('')
